// extracted by mini-css-extract-plugin
export default {"root":"EmailTemplatesPopover_root__4nrAK","pickerList":"EmailTemplatesPopover_pickerList__3TNRK"};